module.exports = (function() { return this["wp"]["components"]; }());